// extracted by mini-css-extract-plugin
module.exports = {"product-css":"ProductInner_product-css_37Axo","banner-top":"ProductInner_banner-top_1NKVy","fave-button":"ProductInner_fave-button_VW9Ps"};